// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ClientEndpoint, IClientEndpoint } from "./ClientEndpoints.ClientEndpoint.gen";

export interface IEventTriggerClientEndpoint {
	eventTriggerId: string | undefined;

	clientEndpointId: string | undefined;

	clientEndpoint: IClientEndpoint | undefined;

	minValue: number | undefined;

	maxValue: number | undefined;

	additionalValue: number | undefined;

	endpointConfig: string | undefined;

	$type?: string | undefined;
}
export class EventTriggerClientEndpoint {
	constructor(data?: IEventTriggerClientEndpoint) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.clientEndpoint) { this.clientEndpoint = new ClientEndpoint(data.clientEndpoint); }
	}

	eventTriggerId: string | undefined;

	clientEndpointId: string | undefined;

	clientEndpoint: ClientEndpoint | undefined;

	minValue: number | undefined;

	maxValue: number | undefined;

	additionalValue: number | undefined;

	endpointConfig: string | undefined;

	static $type: string = "CoreApi.Models.EventTriggers.EventTriggerClientEndpoint, ";
	$type?: string | undefined = EventTriggerClientEndpoint.$type;
}

